import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoanFormData, RulesResult } from '../types';
import api from '../api';
import NavBar from '../components/NavBar';
import LoanForm from '../components/LoanForm';
import RatioPanel from '../components/RatioPanel';
import ExceptionPanel from '../components/ExceptionPanel';

export default function NewLoan() {
  const navigate = useNavigate();
  const [rulesResult, setRulesResult] = useState<RulesResult | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [evaluating, setEvaluating] = useState(false);

  const handleRulesResult = (result: RulesResult) => {
    setEvaluating(false);
    setRulesResult(result);
  };

  const handleSubmit = async (data: LoanFormData) => {
    setSubmitting(true);
    try {
      const res = await api.post('/loans', { ...data, status: '01-Loan Modeling' });
      navigate(`/loans/${res.data.id}`);
    } catch (err: any) {
      alert(err.response?.data?.error || 'Failed to create loan');
    } finally {
      setSubmitting(false);
    }
  };

  const exceptions = (rulesResult as any)?.exceptions || [];

  return (
    <div className="min-h-screen bg-[#0F1117]">
      <NavBar />
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate('/dashboard')}
            className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
          >
            ← Pipeline
          </button>
          <span className="text-gray-700">/</span>
          <h1 className="text-lg font-semibold text-white">New Loan Application</h1>
        </div>

        {/* Layout: form left, results right */}
        <div className="grid grid-cols-5 gap-6">
          {/* Form — 60% */}
          <div className="col-span-3">
            <LoanForm
              onRulesResult={handleRulesResult}
              onSubmit={handleSubmit}
              submitting={submitting}
              rulesResult={rulesResult}
            />
          </div>

          {/* Results panel — 40% */}
          <div className="col-span-2 space-y-3">
            <div className="sticky top-4 space-y-3">
              <ExceptionPanel exceptions={rulesResult ? exceptions : null} />
              <RatioPanel result={rulesResult} loading={evaluating} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
